import React from "react";
import {
    VideoStatusCssClasses,
  VideoStatusTitles
} from "../UIHelpers";

export const VideoStatusColumnFormatter = (cellContent, row) => (
    <span
      className={`label label-lg label-light-${VideoStatusCssClasses[row.status]
        } label-inline`}
    >
      {VideoStatusTitles[row.status]}
    </span>
);
